<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (desktop) {
            <div class="targeted-promotions-layout row results">
                <div class="col12 col-md-8">
                    @if (vm.playerActivityContent?.myProgress?.slabContent) {
                        <criteria-carousel></criteria-carousel>
                    }
                    <player-activity-currently-achieved></player-activity-currently-achieved>
                    <base-details-terms-conditions [detailsContent]="vm.baseDetailsContent" [clientContent]="vm.commonContentMessages">
                    </base-details-terms-conditions>
                </div>
                <div class="col12 col-md-4">
                    <pre-requisite id="preRequisite" [isDeposit]="true" [preRequisite]="vm.preRequisite"> </pre-requisite>
                    <pre-requisite id="totalWagered" [preRequisite]="vm.totalWagered"></pre-requisite>
                    <tp-rewards [rewardContent$]="rewardsContent$"></tp-rewards>
                </div>
            </div>
        }
        @if (!desktop) {
            <div class="targeted-promotions-layout results">
                <div class="col">
                    @if (vm.preRequisite) {
                        <pre-requisite id="preRequisite" [isDeposit]="true" [preRequisite]="vm.preRequisite"> </pre-requisite>
                    }
                    @if (vm.playerActivityContent?.myProgress?.slabContent) {
                        <criteria-carousel></criteria-carousel>
                    }
                    <pre-requisite id="totalWagered" [preRequisite]="vm.totalWagered"></pre-requisite>
                    <player-activity-currently-achieved></player-activity-currently-achieved>
                    <base-details-terms-conditions [detailsContent]="vm.baseDetailsContent" [clientContent]="vm.commonContentMessages">
                    </base-details-terms-conditions>
                </div>
            </div>
        }
    }
</ng-container>
